import { Component, AfterViewInit, Output, ViewChild, EventEmitter, ElementRef, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, NgClass, NgIf } from '@angular/common';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { Utils } from 'src/app/shared/utils';
import { HeartHeaderComponent } from '../../../../../../../shared/lista-deseos/heart-header/heart-header.component';

@Component({
  selector: 'app-galapagostrails',
  templateUrl: './galapagostrails.component.html',
  styleUrls: ['./galapagostrails.component.scss'],
  imports: [NgClass, NgIf, HeartHeaderComponent]
})
export class GalapagostrailsComponent implements AfterViewInit {
  @Output() public headerHeight: EventEmitter<any> = new EventEmitter();
  @ViewChild('header') headerRef!: ElementRef;
  @Output() public headerHeight1: EventEmitter<any> = new EventEmitter();
  @ViewChild('header1') headerRef1!: ElementRef;

  showMenu: boolean = false;
  scrolledPast: boolean = false;
  scrollingDown: boolean = false;
  openSubmenu: string | null = null;
  private lastScrollY = 0;

  constructor(
    public companyParamsService: CompanyParamsService,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  ngAfterViewInit() {
    setTimeout(() => {
      var height = this.headerRef.nativeElement.offsetHeight;
      this.headerHeight.emit(height);
      var height1 = this.headerRef1.nativeElement.offsetHeight;
      this.headerHeight1.emit(height1);
    }, 300);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!isPlatformBrowser(this.platformId)) { return; }
    const y = Math.max(window.scrollY || window.pageYOffset || 0, 0);
    const delta = y - this.lastScrollY;
    // Igual que el sitio: solo cambia la dirección con un desplazamiento mínimo de 6px
    if (Math.abs(delta) >= 6) {
      this.scrollingDown = delta > 0;
      this.lastScrollY = y;
    }
    this.scrolledPast = y > 24;
  }

  renderMenu() {
    this.showMenu = !this.showMenu;
    if (!this.showMenu) { this.openSubmenu = null; }
  }

  toggleSubmenu(key: string, event: Event) {
    if (!isPlatformBrowser(this.platformId)) { return; }
    if (window.innerWidth <= 980) {
      event.preventDefault();
      this.openSubmenu = this.openSubmenu === key ? null : key;
    }
  }

  goFavorites() {
    const urlFavorites: any = this.companyParamsService.getNameUrl() + '/wishlist';
    Utils.openNewTab(urlFavorites);
  }
}
